const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';
const INVENTARIO_INSUMOS_API_URL = `${API_URL}/inventario-insumos`;

export const fetchInventarioInsumos = async ({ limit = 10, offset = 0, query = {} }) => {
  try {
    const response = await fetch(`${INVENTARIO_INSUMOS_API_URL}/filter`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ limit, offset, query }),
    });
    if (!response.ok) throw new Error('Error al obtener el inventario de insumos');
    return await response.json();
  } catch (error) {
    console.error('Error fetching inventario insumos:', error);
    throw error;
  }
};

export const createInventarioInsumo = async (data) => {
  try {
    const response = await fetch(`${INVENTARIO_INSUMOS_API_URL}/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error('Error al crear el inventario de insumo');
    return await response.json();
  } catch (error) {
    console.error('Error creating inventario insumo:', error);
    throw error;
  }
};

export const updateInventarioInsumo = async (id, data) => {
  try {
    const response = await fetch(`${INVENTARIO_INSUMOS_API_URL}/update/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error('Error al actualizar el inventario de insumo');
    return await response.json();
  } catch (error) {
    console.error('Error updating inventario insumo:', error);
    throw error;
  }
};

export const deleteInventarioInsumo = async (id) => {
  try {
    const response = await fetch(`${INVENTARIO_INSUMOS_API_URL}/delete/${id}`, {
      method: 'DELETE',
    });
    if (!response.ok) throw new Error('Error al eliminar el inventario de insumo');
    return await response.json();
  } catch (error) {
    console.error('Error deleting inventario insumo:', error);
    throw error;
  }
};

export const exportInventarioInsumos = async (query = {}) => {
  try {
    const response = await fetch(`${INVENTARIO_INSUMOS_API_URL}/export`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query }),
    });
    if (!response.ok) throw new Error('Error al exportar el inventario de insumos');
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error('Error exporting inventario insumos:', error);
    throw error;
  }
};

export const registrarEntrada = async (id, cantidad) => {
  try {
    const response = await fetch(`${INVENTARIO_INSUMOS_API_URL}/entrada/${id}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ cantidad }),
    });
    if (!response.ok) throw new Error('Error al registrar entrada');
    return await response.json();
  } catch (error) {
    console.error('Error registrando entrada:', error);
    throw error;
  }
};

export const registrarSalida = async (id, cantidad) => {
  try {
    const response = await fetch(`${INVENTARIO_INSUMOS_API_URL}/salida/${id}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ cantidad }),
    });
    if (!response.ok) throw new Error('Error al registrar salida');
    return await response.json();
  } catch (error) {
    console.error('Error registrando salida:', error);
    throw error;
  }
};

export const getBajoStock = async () => {
  try {
    const response = await fetch(`${INVENTARIO_INSUMOS_API_URL}/alertas/bajo-stock`);
    if (!response.ok) throw new Error('Error al obtener insumos con bajo stock');
    return await response.json();
  } catch (error) {
    console.error('Error fetching bajo stock:', error);
    throw error;
  }
};

export const fetchInsumoStockByNames = async (nombres) => {
  try {
    const response = await fetch(`${INVENTARIO_INSUMOS_API_URL}/stock-by-names`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ nombres }),
    });
    if (!response.ok) throw new Error('Error al obtener stock de insumos');
    return await response.json();
  } catch (error) {
    console.error('Error fetching insumo stock by names:', error);
    throw error;
  }
};

export const agregarMultiplesInsumos = async (insumos) => {
  try {
    const response = await fetch(`${INVENTARIO_INSUMOS_API_URL}/agregar-multiples`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ insumos }),
    });
    if (!response.ok) throw new Error('Error al agregar múltiples insumos');
    return await response.json();
  } catch (error) {
    console.error('Error agregando múltiples insumos:', error);
    throw error;
  }
};
